import { Link } from 'react-router-dom';
import { SearchX } from 'lucide-react';

import { Button } from '../components/Button';
import { EmptyState } from '../components/EmptyState';

export function NotFoundPage() {
  return (
    <main style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}>
      <EmptyState
        icon={<SearchX size={20} />}
        title="Страница не найдена"
        description="Проверьте адрес или вернитесь к проектам."
        action={
          <Link to="/">
            <Button variant="primary">К проектам</Button>
          </Link>
        }
      />
    </main>
  );
}
